import styled from 'styled-components'

const Container = styled.div<{ collapsed?: boolean }>`
  position: relative;
  header {
    position: relative;

    .option-user {
      position: absolute;
      top: 0;
      right: 0;
      margin-right: 15px;

      a {
        padding-left: 8px;
      }
    }

    .selectCliente {
      position: absolute;
      top: 15px;
      left: 50px;
    }
  }

  .ant-dropdown-menu-item {
    color: red !important;
  }

  .area-menu {
    position: relative;
  }

  .trigger-responsive {
    position: absolute;
    background-color: #fff;
    z-index: 99999;
    right: -40px;
    padding: 10px;
    font-size: 18px;
    line-height: 76px;
    cursor: pointer;
    transition: color 0.3s;
    border-radius: 4px;
  }

  .trigger-responsive:hover {
    color: #1890ff;
  }

  .trigger {
    position: absolute;
    left: 0;
    padding: 0 24px;
    font-size: 18px;
    line-height: 76px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: #1890ff;
  }

  .area-logo {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 30 !important;
    height: 76px;
    background: #fff;
    padding: 0;
  }

  .logo {
    height: 75px;
  }

  .logo-sm {
    height: 55px;
  }

  .logo-test {
    height: 58px;

    img {
      width: 140px;
    }
  }

  .logo-sm-test {
    height: 58px;

    img {
      width: 68px;
    }
  }

  .logo-cliente {
    height: 64px;
    background: #fff;
    max-width: 68px;
  }

  .site-layout .site-layout-background {
    background: #fff;

    span:hover {
      color: #4caf50;
    }
  }

  .corThema {
    background: linear-gradient(0deg, rgba(64, 128, 128, 1) 0%, rgba(59, 80, 99, 1) 50%);
    height: 91vh;

    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }

  .ant-menu-item-selected {
    background: linear-gradient(0deg, rgba(64, 128, 128, 1) 0%, rgba(59, 80, 99, 1) 50%) !important;
  }

  .ant-menu-inline.ant-menu-sub {
    background-color: rgba(59, 80, 99, 1) !important;
  }

  .ant-menu-item {
    font-weight: 500;
  }

  .ant-dropdown-menu-item {
    span {
      font-size: 50px !important;
      color: red;
    }
  }

  .title > div > span {
    padding-top: 5px;
  }

  .title .anticon {
    padding-top: 5px;
  }

  .loadingMenu {
    .ant-spin-dot-item:nth-child(1) {
      background-color: #fff;
    }

    .ant-spin-dot-item:nth-child(2) {
      background-color: #d2d2d2;
    }

    .ant-spin-dot-item:nth-child(3) {
      background-color: #bcbcbc;
    }

    .ant-spin-dot-item:nth-child(4) {
      background-color: #ababab;
    }
  }

  .option-user {
    display: flex;
  }

  .loader {
    display: flex;
    min-width: 100vw;
    min-height: 100vh;
    background: linear-gradient(0deg, rgba(64, 128, 128, 1) 0%, rgba(59, 80, 99, 1) 50%);
    justify-content: center;
    align-items: center;

    .logo-loader {
      text-align: center;

      img {
        padding-bottom: 15px;
      }
    }
  }

  .ant-menu-item,
  .ant-menu-submenu {
    z-index: 2;
  }

  .version-list {
    z-index: 40;
    margin-top: 15px;
    width: ${(p) => (p.collapsed ? '78px' : '250px')};
    position: fixed;
    bottom: 0;
    background-color: #3f767a;
    cursor: pointer;
    height: 20px;
    align-items: center;
    text-align: left;
    display: flex;
    justify-content: left;
    transition: 0.2s;

    span {
      padding: 10px;
      font-size: 11px;
    }
  }

  .version-list:hover {
    background-color: #37676b;
  }
`

export default Container
